/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import "tippy.js/dist/tippy.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./TrucTuyen.scss";
import { PopPupQrTrucTuyen } from "./PopPupQr";
import { getFromlocalstorage, saveTolocalstorage } from "../../../../component/MaHoaDuLieu";
import Loading from "../../../../component/Loading/Loading";


const TrucTuyen = () => {
  const apiUrl = process.env.REACT_APP_API_BACKEND;
  const data = JSON.parse(getFromlocalstorage("data_u"));

  const [tienvalue, settienvalue] = useState("");
  const [isOpen, setisOpen] = useState(false);
  const [bankData, setBankData] = useState(null);
  const [loading, setLoading] = useState(false);

  const tien = [
    { tien: "50", value: "50,000", tienvalue: 50 },
    { tien: "100", value: "100,000", tienvalue: 100 },
    { tien: "500", value: "500,000", tienvalue: 500 },
    { tien: "1,000", value: "1,000,000", tienvalue: 1000 },
    { tien: "2,000", value: "2,000,000", tienvalue: 2000 },
    { tien: "5,000", value: "5,000,000", tienvalue: 5000 },
    { tien: "10,000", value: "10,000,000", tienvalue: 10000 },
    { tien: "50,000", value: "50,000,000", tienvalue: 50000 },
    { tien: "100,000", value: "100,000,000", tienvalue: 100000 },
  ];

  const handleDeposit = async () => {
    const amountToSend = Number(tienvalue);

    if (!amountToSend) {
      toast.error("กรุณากรอกจำนวนเงิน");
      return;
    }

    if (amountToSend < 100) {
      toast.error("จำนวนเงินขั้นต่ำคือ 100 THB");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${apiUrl}/naptien/${data._id}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          amount: amountToSend,
          type: "deposit",
        }),
      });

      const resData = await response.json();
      if (response.ok) {
        saveTolocalstorage("data_b", JSON.stringify(resData.bankjson));
        setBankData(resData.transactions);
        setisOpen(true); // mở modal QR
      } else {
        toast.error(resData.message || "ฝาก ไม่สำเร็จ");
      }
    } catch (error) {
      toast.error("เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tab-content_nap">
      <ToastContainer position="top-right" autoClose={3000} />
      <Loading isLoading={loading} />

      <div className="list-group-depoin">
        <div className="box-right-depoins">
          <form action="">
            <div className="divtientong">
              <div className="pay_listtructuyen_title">
                  จำนวนเงินที่แนะนำสำหรับการชำระเงิน:
              </div>
              <div className="divtien">
                {tien.map((item, index) => (
                  <div
                    className="divtien_item"
                    key={index}
                    onClick={() => {
                      settienvalue(item.tienvalue);
                    }}
                  >
                    {item.tien}
                  </div>
                ))}
              </div>
            </div>

            <div className="divchonnganhang_poind">
              <label htmlFor="" className="pay_listtructuyen_title">
                  จำนวนเงินฝาก
              </label>
              <div className="divinputnhapsotien_poind">
                <input
                  type="number"
                  value={tienvalue}
                  placeholder="กรอกจำนวนเงิน"
                  onChange={(e) => settienvalue(e.target.value)}
                />
              </div>
              <div className="chonganhangfooter_poind">
                <span className="pay_listtructuyen_title margin_none">
                  = {(Number(tienvalue) * 1).toLocaleString()} THB
                </span>
              </div>
            </div>
            <div className="footer_vh"></div>
          </form>
        </div>
      </div>

      <div className="footer_nap_submit">
        <div className="footer_nap_submit_btn">
          <button
            type="button"
            className="footer_nap_submit_btn_submit"
            onClick={handleDeposit}
          >
              ยืนยันการฝากเงิน
          </button>
        </div>
      </div>

      {/* Modal QR */}
      <PopPupQrTrucTuyen
        isOpen={isOpen}
        setisOpen={setisOpen}
        bankData={{ ...bankData, amount: tienvalue }}
      />
    </div>
  );
};

export default TrucTuyen;
